import React from 'react';

export const AlertMessageBox: React.FC<{
  message: string | undefined;
}> = ({ message }) => {
  React.useEffect(() => {
    if (!message) {
      return;
    }

    window.scrollTo(0, 0);
  }, [message]);

  return message ? (
    <div className="mb-12 rounded-2 border-2 border-solid border-caution-primary bg-base-100 p-4 text-base2 font-bold cst-halt leading-[1.4] text-caution-primary">
      {message}
    </div>
  ) : null;
};
